module.exports = __webpack_public_path__ + "img/frame--horizontal.510b11a.png";